<script setup lang="ts">
import { PRODUCT_LOGO_ASSET, PRODUCT_LOGO_STYLE } from '@/constants';
import { DgrIcon } from '@stockmarkteam/donguri-ui';

// 取得結果をキャッシュしている箇所が複数あるため、画面ごと読み込み直す
const reload = () => {
  window.location.reload();
};
</script>

<template>
  <div class="capability-error">
    <header class="header">
      <img
        :src="PRODUCT_LOGO_ASSET"
        :style="PRODUCT_LOGO_STYLE"
        alt="Aconnect"
      />
    </header>
    <main class="content">
      <div class="message">
        <p class="c-title-medium--xm">
          情報を取得できません、再読み込みしてください。
        </p>
        <p class="c-text c-text--m">
          再読み込みしても表示されない場合は、管理者にお問い合わせください。
        </p>
      </div>
      <button
        type="button"
        class="c-btn c-btn--small c-btn--auto c-btn--AnewsPrimary reload-button"
        @click="reload"
      >
        <DgrIcon name="sync" size="small" :keep-fill="false" />
        再度読み込む
      </button>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.capability-error {
  min-height: 100vh;
  background: $color-white;
}

.header {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 64px;
  padding: 12px;
  background: $color-white;
  box-shadow: 0 1px 5px rgba(74, 74, 74, 0.25);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
}

.message {
  text-align: center;
  color: $color-gray1000;

  p {
    margin: 0;
  }
}

.reload-button {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
